import React, { FC } from 'react';
import classNames from 'classnames';
import style from './checkbox.module.scss';

export interface CheckboxProps {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: () => void;
  className?: string;
  error: any;
}

const Checkbox: FC<CheckboxProps> = ({
  label,
  checked,
  disabled = false,
  error,
  onChange,
  className,
}) => {
  return (
    <div
      className={classNames(style['checkbox'], {
        [`${className}`]: !!className,
      })}
    >
      <input
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        type={'checkbox'}
      />
      <div className={style['checkbox__label']}>{label}</div>
      <div className={style['checkbox__error']}>{error?.message}</div>
    </div>
  );
};

export default Checkbox;
